import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        defaultFilter: '=',
        filterOverview: '=',
        filter: '=',
        sites: '=',
        classifiers: '='
    },
    template: `
        <div class="table-filters">
            <form class="form form-filter" ng-submit="vm.applyFilter()">
                <div class="fields">
                    <div class="row row-separated">
                        <label class="label">{{ 'filter.Site' | translate }}</label>
                        <div class="items">
                            <div
                                ng-dropdown-multiselect=""
                                options="vm.multiFilter.sites.options"
                                selected-model="vm.multiFilter.sites.model"
                                extra-settings="vm.multiFilter.sites.settings"
                                ng-click="vm.updateEmployees()"
                                translation-texts="vm.filterTranslations"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'filter.Department' | translate }}</label>
                        <div class="items">
                            <select class="form-control" ng-model="vm.filter.departmentId"
                                ng-options="item.id as item.value for item in vm.departments">
                            <option value=""></option>
                        </select>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'filter.Role' | translate }}</label>
                        <div class="items">
                            <select class="form-control" ng-model="vm.filter.roleId"
                                ng-options="item.id as item.value for item in vm.roles">
                            <option value=""></option>
                        </select>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'filter.Level' | translate }}</label>
                        <div class="items">
                            <select class="form-control" ng-model="vm.filter.levelId"
                                ng-options="item.id as item.value for item in vm.levels">
                            <option value=""></option>
                        </select>
                        </div>
                    </div>
                    <div class="row row-md">
                        <label class="label">{{ 'filter.Employee' | translate }}</label>
                        <div class="items">
                            <autocomplete
                                label-attribute="'displayName'"
                                selected-item="vm.selectedEmployee"
                                ng-model="vm.filter.userId"
                                value-attribute="'id'"
                                placeholder="vm.$translate.instant('filter.Find an employee')"
                                query="vm.queryUsers(input)"
                            />
                        </div>
                    </div>
                    <div ng-if="vm.periodFilterSelectValues" class="row">
                      <label class="label">{{ 'filter.Period' | translate }}</label>
                      <div class="items">
                        <select class="form-control"
                                ng-model="vm.filter.year"
                                ng-options="value as label for (value, label) in vm.periodFilterSelectValues track by value">
                        </select>
                      </div>
                    </div>
                </div>
                <ul class="actions01">
                    <li><input type="button" ng-click="vm.resetFilter()" class="btn discrete" value="{{ 'filter.Reset' | translate }}"></li>
                    <li><input type="submit" class="btn main" value="{{ 'filter.Generate report' | translate }}"></li>
                </ul>
            </form>
        </div>
    `
})
export default class {
    constructor ($translate, lodash, moment, MomentService, FilterService, CLASSIFIER_ENUM, COURSE_STATUS_TYPE_ENUM, ROLE_CODE_ENUM,
                 UserResource, ClassifierBudgetResource) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.moment = moment;
        this.MomentService = MomentService;
        this.FilterService = FilterService;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.COURSE_STATUS_TYPE_ENUM = COURSE_STATUS_TYPE_ENUM;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
        this.UserResource = UserResource;
        this.ClassifierBudgetResource = ClassifierBudgetResource;
    }

    $onInit () {
        this.departments = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.DEPARTMENT);
        this.roles = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.ROLE);
        this.levels = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.LEVEL);

        this.filter.year = this.filter.year.toString();

        this.initMultiFilter();

        this.setPeriodFilterSelect();

        this.filterOverview = {
            labels: {
                period: this.$translate.instant('filter.Period'),
                'siteIds[]': this.$translate.instant('filter.Site'),
                departmentId: this.$translate.instant('filter.Employee department'),
                roleId: this.$translate.instant('filter.Employee role'),
                levelId: this.$translate.instant('filter.Employee level'),
                userId: this.$translate.instant('filter.Employee')
            },
            values: {}
        };
        this.filterTranslations = this.FilterService.getTranslations();
        this.updateFilterOverview();
    }

    setPeriodFilterSelect () {
        this.periodFilterSelectValues = {};

        // get the first budget by periodStartDate
        this.ClassifierBudgetResource.getStartYear().$promise.then((response) => {
            if (response) {
                for (let year = parseInt(this.moment(response.periodStartDate).format('YYYY'), 10); year <= parseInt(this.moment().format('YYYY'), 10); year++) {
                    this.periodFilterSelectValues[year.toString()] = year;
                }
            }
        });
    }

    applyFilter () {
        const siteIds = !this.multiFilter.sites.model.length ? [-1] : this.multiFilter.sites.model.map(site => site.value);

        this.filter.periodStartDate = `${this.filter.year}-01-01`;
        this.filter.periodEndDate = `${this.filter.year}-12-31`;

        this.filter = this.lodash.assign(this.filter, { 'siteIds[]': siteIds });
        this.list.fetch(this.filter).then(() => {
            this.updateFilterOverview();
        });
    }

    resetFilter () {
        this.filter = angular.copy(this.defaultFilter);
        this.multiFilter = angular.copy(this.defaultMultiFilter);
        this.applyFilter();
        this.selectedEmployee = null;
    }

    updateFilterOverview () {
        if (!this.list.invalid) {
            // empty old values
            this.filterOverview.values = {};
            this.lodash.forEach(this.filter, (value, key) => {
                if (key === 'siteIds[]' && value[0] !== -1) {
                    this.filterOverview.values[key] = value.map((siteId) => this.lodash.find(this.sites, { id: siteId }).name).join('; ');
                }
                else if (key === 'departmentId') {
                    this.filterOverview.values[key] = (this.lodash.find(this.departments, { id: value }) || {}).value;
                }
                else if (key === 'roleId') {
                    this.filterOverview.values[key] = (this.lodash.find(this.roles, { id: value }) || {}).value;
                }
                else if (key === 'levelId') {
                    this.filterOverview.values[key] = (this.lodash.find(this.levels, { id: value }) || {}).value;
                }
                else if (key === 'userId') {
                    this.filterOverview.values[key] = this.selectedEmployee.displayName;
                }
            });
            // get filter period
            if (this.filter.year) {
                const from = this.MomentService.formatDate(`${this.filter.year}-01-01`);
                const to = this.MomentService.formatDate(`${this.filter.year}-12-31`);
                this.filterOverview.values.period = `${from} - ${to}`;
            }
        }
    }

    initMultiFilter () {
        const siteOptions = this.sites.map(site => {
            return {
                value: site.id,
                label: site.name
            };
        });
        const siteOptionsSelected = siteOptions.map(site => site);
        this.multiFilter = {
            sites: {
                model: siteOptionsSelected,
                options: siteOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            }
        };
        // this is used when filter is reset
        this.defaultMultiFilter = angular.copy(this.multiFilter);
    }

    queryUsers (input) {
        const params = {
            roleCode: this.ROLE_CODE_ENUM.KEYS.EMPLOYEE,
            name: input,
            pageSize: 0
        };
        const siteIds = this.multiFilter.sites.model.map(site => site.value);
        if (siteIds) {
            params['siteIds[]'] = siteIds;
        }
        return this.UserResource.query(params).$promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/reports/budget/filter/index.js